// @flow
import React from 'react';
import { getContactHref } from '../../../utils';
import styles from './Author.module.scss';
import { useSiteMetadata, useAppDarkMode } from '../../../hooks';


const Author = () => {
  const { author } = useSiteMetadata();
  const { value } = useAppDarkMode(false);

  return (
    <div className={styles[value ? 'dark-author' : 'light-author']}>
      <p className={styles[value ? 'dark-author__bio  ' : 'light-author__bio']}>
        {author.bio}
        <a
          className={styles[value ? 'dark-author__bio-twitter' : 'light-author__bio-twitter']}
          href={getContactHref('substack', author.contacts.substack)}
          rel="noopener noreferrer"
          target="_blank"
        >
          <strong>{author.name}'s</strong> Substack newsletter
        </a>
      </p>
    </div>
  );
};

export default Author;
